import React from 'react';
import { connect } from 'react-redux';
import { ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { Route, Routes } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import Header from 'components/Header';
import Breadcrumb from 'components/Breadcrumb';
import ContentWrapper from 'components/ContentWrapper';
import Footer from 'components/Footer';
import SplashPage from 'pages/SplashPage';
import SiteRoutes from 'routes';
import { removeNotification } from 'state/actions';
import '@fontsource/roboto';
import '@fontsource/roboto-slab';
import '@progress/kendo-theme-default/dist/all.css';
import './App.css';

const theme = createTheme({ palette: { type: 'light', primary: { main: '#0f487e' } } });

const useStyles = makeStyles((theme) => ({
  snackBar: { minWidth: '50%' },
  alertContainer: { width: '100%' },
  alerts: {
    width: '100%',
    marginTop: '0.5rem',
    whiteSpace: 'pre-line',
  },
}));

const App = ({ summaryLoading: showSplash, notifications }) => {
  const classes = useStyles();
  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        {showSplash ? (
          <SplashPage />
        ) : (
          <>
            <Header />
            <Breadcrumb />
            <ContentWrapper>
              <Routes>
                {SiteRoutes.map(({ element: Element, path, ...rest }) => (
                  <Route path={path} key={`page-${path}`} {...rest} element={<Element />} />
                ))}
                {/* <Route element={NotFoundPage} /> */}
              </Routes>
            </ContentWrapper>
            <Snackbar
              open={notifications.length > 0}
              autoHideDuration={0}
              className={classes.snackBar}
            >
              <Box className={classes.alertContainer}>
                {notifications.map(({ id, message, level }) => (
                  <Alert
                    variant="filled"
                    key={id}
                    onClose={() => {
                      removeNotification(id);
                    }}
                    severity={level}
                    className={classes.alerts}
                  >
                    {message}
                  </Alert>
                ))}
              </Box>
            </Snackbar>
            <Footer />
          </>
        )}
      </ThemeProvider>
    </>
  );
};

const mapStateToProps = ({
  summary: { loading: summaryLoading } = { loading: false },
  notifications = [],
}) => ({
  summaryLoading,
  notifications,
});

export default connect(mapStateToProps)(App);
